import * as React from 'react';

export const BigAuctionIcon = (id: number | string, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="37" viewBox="0 0 40 37" width="40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id={`auction-grad-${id}`} x1="33.598%" x2="89.699%" y1="113.932%" y2="3.534%">
        <stop offset="0%" stopColor="#FF5050" />
        <stop offset="54.2%" stopColor="#FF7B0E" />
        <stop offset="100%" stopColor="#FF8400" />
      </linearGradient>
    </defs>
    {/* tslint:disable-next-line:max-line-length */}
    <path
      d="M2.479 33.769a1.208 1.208 0 0 1 1.137-1.614h9.642a1.208 1.208 0 0 1 1.137 1.614h1.274c.665 0 1.205.542 1.205 1.21 0 .669-.54 1.211-1.205 1.211H1.205A1.208 1.208 0 0 1 0 34.98c0-.669.54-1.211 1.205-1.211H2.48zm21.243-18.146L38.855 28.58a3.28 3.28 0 0 1 .19 4.8 3.244 3.244 0 0 1-4.78-.191l-12.895-15.2a58.076 58.076 0 0 1-4.974 4.113l-6.464-6.492a50.195 50.195 0 0 1 5.22-6.17 50.087 50.087 0 0 1 6.145-5.245l6.463 6.492a57.905 57.905 0 0 1-4.038 4.938zM21.687.591a2.002 2.002 0 0 1 2.84 0l6.25 6.278a2.025 2.025 0 0 1 0 2.854 2.005 2.005 0 0 1-2.84 0l-6.25-6.278a2.023 2.023 0 0 1 0-2.853V.59zM6.345 16.003a2.003 2.003 0 0 1 2.84 0l6.819 6.849a2.025 2.025 0 0 1 0 2.854 2.003 2.003 0 0 1-2.841 0l-6.818-6.85a2.025 2.025 0 0 1 0-2.853zm5.966 3.14l.569-.572 3.977 3.996-.569.569-3.977-3.996v.003zM24.243 7.156l.568-.57 3.978 3.995-.568.57-3.978-3.995z"
      fill={`url(#auction-grad-${id})`}
      fillRule="nonzero"
    />
  </svg>
);
